import { DhlCenter, DhlLoader } from '@dhl-official/react-library';
import React from 'react';
import styled from 'styled-components';

const LoaderContainer = styled(DhlCenter)`
  margin: auto;
`;

const Loader = () => (
  <LoaderContainer>
    <DhlLoader size='sm' color='primary' type='ring' />
  </LoaderContainer>
);

export default Loader;
